import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFees, fetchInsurance } from "../../Redux/WebsiteSlice";
import { useBookingModal } from "../../context/BookingModalContext";
import "./Fees.scss";

const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/uploads/")) return "https://api-test.swifttoolskit.cloud/api" + url;
  return url;
};

const Fees = () => {
  const dispatch = useDispatch();
  const fees = useSelector((state) => state.website.fees);
  const insurance = useSelector((state) => state.website.insurance);
  const { openModal } = useBookingModal();

  useEffect(() => {
    dispatch(fetchFees());
    dispatch(fetchInsurance());
  }, [dispatch]);

  // Group fees by category, preserving order within each category
  const grouped = fees.reduce((acc, fee) => {
    const cat = fee.category || "General";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(fee);
    return acc;
  }, {});

  const hasFees = fees && fees.length > 0;

  return (
    <div className="page-fees">
      <div className="page-hero">
        <div className="page-hero__content">
          <span className="small__text">TRANSPARENT PRICING</span>
          <h1 className="headline__text">
            Our <span>Fees</span>
          </h1>
          <p className="page-hero__subtitle">
            We believe in clear, upfront pricing. Explore our consultation fees and funding options below.
          </p>
        </div>
      </div>

      <div className="fees-section">
        <div className="fees-section__inner">
          {hasFees ? (
            <>
              <div className="fees-grid">
                {Object.entries(grouped).map(([category, items]) => (
                  <div key={category} className="fees-card">
                    <h2 className="fees-card__title">{category}</h2>
                    <ul className="fees-card__list">
                      {items.map((fee) => (
                        <li key={fee._id} className="fees-card__item">
                          <span className="fees-card__label">{fee.label}</span>
                          <span className="fees-card__price">{fee.price}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div className="fees-note">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p>
                  Fees listed are indicative and may vary. A final quote will be provided at the time of booking.
                  Please contact our clinic directly if you have questions about your specific situation.
                </p>
              </div>
            </>
          ) : (
            <div className="fees-empty">
              <p>Please contact us for current fee information.</p>
            </div>
          )}
        </div>
      </div>

      {insurance && insurance.length > 0 && (
        <div className="fees-health-funds">
          <div className="fees-health-funds__inner">
            <span className="small__text">ACCEPTED PROVIDERS</span>
            <h2 className="headline__text">
              We Accept <span>All Major Health Funds</span>
            </h2>
            <p className="fees-health-funds__subtitle">
              We have HICAPS on-site for instant health fund claims. Bring your health fund card to your appointment.
            </p>
            <div className="fees-health-funds__list">
              {insurance.map((provider) => (
                <div key={provider._id} className="fund-badge">
                  {provider.image ? (
                    <img src={getImageUrl(provider.image)} alt={provider.name} />
                  ) : (
                    provider.name
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="fees-cta">
        <div className="fees-cta__inner">
          <h2>Ready to book your appointment?</h2>
          <p>Our team will confirm any costs with you when you book.</p>
          <button
            type="button"
            onClick={() => setTimeout(openModal, 0)}
            className="site__button site__button_style--solid site__button_shape--default"
          >
            <span className="text">Book an Appointment</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Fees;
